import React, { useState } from 'react';

export default function ResumeSelectorModal({ resumes, onSelect, onClose }) {
    const [selectedResumeId, setSelectedResumeId] = useState(null);

    const handleSelect = (resumeId) => {
        setSelectedResumeId(resumeId);
    };
    
    const handleApplyNow = () => {
        if (selectedResumeId) {
          onSelect(selectedResumeId);
        }
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <span className="close" onClick={onClose}>&times;</span>
                <h2 className="resume-selector-title">Select a Resume</h2>
                <ul className="resume-list">
                {resumes.map((resume) => (
                    <li key={resume.id} className="resume-list-item">
                    <button 
                        onClick={() => handleSelect(resume.id)}
                        className={`resume-button ${selectedResumeId === resume.id ? 'selected' : ''}`}
                    >
                        {resume.title}
                    </button>
                    </li>
                ))}
                </ul>
                {selectedResumeId && (
                <button 
                    onClick={handleApplyNow}
                    style={{
                    marginTop: '20px',
                    padding: '10px 20px',
                    fontSize: '16px',
                    backgroundColor: '#008CBA',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s'
                    }}
                >
                    Apply Now
                </button>
                )}
            </div>
        </div>
    );
}